class QuantitySelection {
  constructor(qtyItems, qtyInput, updatePriceFunc) {
    this.qtyItems = qtyItems;
    this.qtyInput = qtyInput;
    this.updatePriceFunc = updatePriceFunc;

    this.init = this.init.bind(this);

    this.init();
  }

  init() {
    this.qtyItems.forEach((item) => {
      item.addEventListener('click', () => {
        this.qtyItems.forEach((itemInner) => {
          if (itemInner === item) {
            itemInner.classList.add('is-active');
          } else {
            itemInner.classList.remove('is-active');
          }
        });

        const qty = parseInt(item.dataset.qty, 10);
        const cost = parseInt(item.dataset.cost, 10);

        if (!item.contains(this.qtyInput)) {
          this.qtyInput.value = qty;
          this.qtyInput.closest('.js-qtyItem').dataset.qty = qty;

          if (this.updatePriceFunc) {
            this.updatePriceFunc(cost);
          }
        }
      });
    });

    const updateQtyInput = () => {
      const qty = parseInt(this.qtyInput.value, 10);
      const qtyItemsArr = Array.from(this.qtyItems);

      let matchingItem;
      for (let i = 0; i < qtyItemsArr.length; i += 1) {
        const discItem = qtyItemsArr[i];
        if (qty < parseInt(qtyItemsArr[0].dataset.qty, 10)) {
          // eslint-disable-next-line prefer-destructuring
          matchingItem = qtyItemsArr[0];
        } else if (qty >= parseInt(discItem.dataset.qty, 10)) {
          matchingItem = discItem;
        }
      }

      if (matchingItem) {
        if (this.updatePriceFunc) {
          this.updatePriceFunc(matchingItem.dataset.cost);
        }
        this.qtyItems.forEach((item) => {
          item.classList.remove('is-active');
        });
        matchingItem.classList.add('is-active');
      }
    };

    this.qtyInput.addEventListener('change', () => {
      if (this.qtyInput.value === '') {
        this.qtyInput.value = '1';
      }
      updateQtyInput();
    });

    this.qtyInput.addEventListener('keyup', () => {
      if (this.qtyInput.value === '') return;
      updateQtyInput();
    });
  }
}

export default QuantitySelection;
